import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getUser, updateUser } from '../../api/user'

export interface IUserData {
  id: string
  firstName: string
  lastName: string
  email: string
  accountCreatedAt: number
  mentorId: string
  mentorSlug: string
}
export interface UserState {
  user: IUserData | null
  isLoading: boolean
  isUpdating: boolean
  error: string | null
}

export const initialState: UserState = {
  user: null,
  isLoading: false,
  isUpdating: false,
  error: null,
}

export interface UpdateUserPayload {
  userSub: string
  data: { firstName: string; lastName: string }
}

export interface UpdateUserResponse {
  success: boolean
  message: string
  data: {
    isSuccess: boolean
    errorCode: string
    payload: IUserData
  }
}

export const fetchUserAction = createAsyncThunk('user/fetchUser', async () => {
  const response = await getUser()
  return response
})

export const updateUserAction = createAsyncThunk<
  UpdateUserResponse,
  UpdateUserPayload
>('user/updateUser', async data => {
  const { userSub, data: userData } = data
  const response = await updateUser(userSub, userData)
  return response
})

const FETCH_USER_ERROR = 'Failed to fetch user'
const UPDATE_USER_ERROR = 'Failed to update user'

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUserData>) => {
      state = {
        ...state,
        user: action.payload,
      }
    },
    setMentorId: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user = {
          ...state.user,
          mentorId: action.payload,
        }
      }
    },
    clearMentorId: state => {
      if (state.user) {
        state.user = {
          ...state.user,
          mentorId: '',
        }
      }
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserAction.pending, state => {
        state.isLoading = true
      })
      .addCase(fetchUserAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.user = action.payload.data
        state.error = null
      })
      .addCase(fetchUserAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message || FETCH_USER_ERROR
      })
      .addCase(updateUserAction.pending, state => {
        state.isUpdating = true
      })
      .addCase(updateUserAction.fulfilled, (state, action) => {
        console.log('action', action)
        const { firstName, lastName } = action.payload.data.payload
        if (state.user) {
          state.user = {
            ...state.user,
            firstName,
            lastName,
          }
        }
        state.isUpdating = false
        state.error = null
      })
      .addCase(updateUserAction.rejected, (state, action) => {
        state.isUpdating = false
        state.error = action.error.message || UPDATE_USER_ERROR
      })
  },
})

export const { setUser, setMentorId, clearMentorId } = userSlice.actions

export default userSlice.reducer
